<template>
    <div>

        <div class="filter-businesses-toggle mb-60">
            <label class="filter-button input-button">
                <input type="checkbox" :value="true"
                       v-model="showFilterHolder">
                <span>
                    Filter Businesses
                    <i v-if="readVoucherSuburbs && readVoucherCategories" class="d-inline-block ml-1 fe fe-sliders"></i>
                    <i v-else class="d-inline-block ml-1 fe fe-loader spin"></i>
                </span>
            </label>
        </div>

        <div class="filter-holder text-white mb-60" v-if="showFilterHolder">
            <h2>
                Filter businesses
                <i v-if="$apollo.queries.readListVouchers.loading" class="d-inline-block ml-1 fe fe-loader spin"></i>
            </h2>

            <h3>by Business Name</h3>
            <p class="row mx-0">
                <input type="text" class="col-10 col-lg-6 form-control" v-model="filterTitleHold">
                <button class="btn btn-outline-white col-2" v-if="filterTitleHold.length > 2" v-on:click.prevent="doTextFilter">Apply</button>
                <button v-if="filterTitleHold" class="btn btn-outline-cool-blue col-2 inline-block underline ml-2 cursor-pointer" v-on:click="clearTitleFilters">clear</button>
            </p>

            <h3>by location</h3>
            <p v-if="readVoucherSuburbs">
                <label class="filter-checkbox input-button"
                       v-for="suburb in readVoucherSuburbs">
                    <input type="checkbox" :value="suburb.suburb"
                           v-model="filtersuburbs">
                    <span v-if="suburb.suburb">{{ suburb.suburb }}</span>
                    <span v-else>None</span>
                </label>
            </p>
            <div v-else>
                Loading filters
            </div>


            <h3>by business type</h3>
            <p v-if="readVoucherCategories">
                <label class="filter-checkbox input-button"
                       v-for="category in readVoucherCategories.nodes">
                    <input type="checkbox" :value="parseInt(category.id)"
                           v-model="filtercategories">
                    <span>{{ category.title }}</span>
                </label>
            </p>
            <div v-else>
                Loading filters
            </div>

        </div>


        <div class="loading-text mb-60">
            <span v-if="$apollo.queries.readListVouchers.loading">Finding businesses
                <i class="d-inline-block ml-1 fe fe-loader spin"></i></span>
            <span v-else>Displaying {{ readListVouchers.length }} businesses </span>
        </div>

        <div v-if="readListVouchers" class="listing-container">
            <div class="listing-outer" v-for="voucher in readListVouchers" :key="voucher.id">
                <div class="listing-inner">

                    <div class="feature-image">
                        <img v-if="voucher.image" :src="voucher.image" :alt="voucher.title" loading="lazy" class="img-fluid">
                    </div>
                    <div class="inner-text">
                        <div class="voucher-title h4" :class="(voucher.image)? 'yes-mt' : 'no-mt'">{{ voucher.title }}</div>
                        <div class="voucher-address">
                            <i class="fe fe-map-pin"></i>
                            <span>{{ voucher.displayAddress }}</span>
                        </div>
                        <div class="voucher-link">
                            <i class="fe fe-globe"></i>
                            <a :href="voucher.websiteLink">{{ voucher.websiteDisplayLabel }}</a>
                        </div>
                        <div class="voucher-categories">
                            <span v-for="category in voucher.categories" :key="category"><span>{{ category
                                }}</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div v-if="filtercategories.length > 0 || filtersuburbs.length > 0" class="filtered-error">
                <p>Sorry, no businesses match your filter criteria.</p>
                <p>Please try again with some different filters.</p>
            </div>
        </div>

    </div>

</template>

<script>


// This is everything we need to work with Apollo 2.0.
import {ApolloClient} from 'apollo-client';
import {HttpLink} from 'apollo-link-http';
import {InMemoryCache} from 'apollo-cache-inmemory';
import VueApollo from 'vue-apollo';
import gql from 'graphql-tag';

// Register the VueApollo plugin with Vue.
Vue.use(VueApollo);

// Create a new HttpLink to connect to your GraphQL API.
// According to the Apollo docs, this should be an absolute URI.
const httpLink = new HttpLink({
    uri: solout.baseUrl + `graphql`
});

// I'm creating another variable here just because it makes it easier to add more links in the future.
const link = httpLink;

// Create the apollo client
const apolloClient = new ApolloClient({
    // Tells Apollo to use the link chain with the http link we set up.
    link,
    // Handles caching of results and mutations.
    cache: new InMemoryCache(),
    // Useful if you have the Apollo DevTools installed in your browser.
    connectToDevTools: false,
});

const apolloProvider = new VueApollo({
    // Apollo 2.0 allows multiple clients to be enabled at once.
    // Here we select the default (and only) client.
    defaultClient: apolloClient,
});

export default {
    name: "voucher-list.vue",
    data: function () {
        return {
            showFilterHolder: false,
            voucherlimit: -1,
            filtersuburbs: [],
            filtercategories: [],
            filtertitle: '',
            filterTitleHold: '',
            offset: -1
        }
    },
    watch: {
    },
    setup: function () {

    },
    methods: {
        doTextFilter: function () {
            if (this.filterTitleHold.length > 2) {
                this.filtertitle = this.filterTitleHold;
            } else {
                this.filtertitle = '';
            }
        },
        clearTitleFilters: function () {
            this.filtertitle = '';
            this.filterTitleHold = '';
        }
    },
    components: {},
    apollo: {
        readListVouchers: {
            query: gql`
                query readListVouchers($limit: Int, $title: String, $suburbs: [String], $categories: [Int], $offset: Int) {
                    readListVouchers (title: $title, suburbs: $suburbs, categories: $categories, limit: $limit, offset: $offset) {
                        id
                        title
                        displayAddress
                        suburb
                        websiteLink
                        websiteDisplayLabel
                        categories
                        image
                    }
                }`,
            variables() {
                return {
                    limit: this.voucherlimit,
                    title: this.filtertitle,
                    suburbs: this.filtersuburbs,
                    categories: this.filtercategories,
                    offset: this.offset
                }
            },
            update: function (data) {
                if (window.innerWidth < 768) {
                    this.showFilterHolder = false;
                }
                return data.readListVouchers;
            },
            fetchPolicy: 'cache-and-network',
        },
        readVoucherCategories: {
            query: gql`
                query {
                    readVoucherCategories {
                        nodes
                        {
                            id
                            title
                        }
                    }
                }`,
            update: result => result.readVoucherCategories,
            fetchPolicy: 'cache-and-network',
        },
        readVoucherSuburbs: {
            query: gql`
                query readVoucherSuburbsQuery {
                    readVoucherSuburbs {
                        suburb
                    }
                }`,
            update: result => result.readVoucherSuburbs,
            fetchPolicy: 'cache-and-network',
        },

    },
    apolloProvider,
    render: h => h(App),
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variables";
@import "../../../scss/mixins";
@import "../../../scss/fonts";

@import "../../../node_modules/bootstrap/scss/functions";
@import "../../../node_modules/bootstrap/scss/variables";
@import "../../../node_modules/bootstrap/scss/mixins";


@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}


.spin {
    border-radius: 30px;
    animation: spin 3s linear infinite
}


.input-button {
    margin-bottom: 10px;

    input {
        display: none;
    }
}


.loading-text {
    text-align: center;

    span {
        margin-right: auto;
        margin-left: auto;
        font-size: 27px;
        letter-spacing: 0.27px;
        color: $black;
        border-bottom: 2px solid $color-cool-blue;
    }
}


.mb-60 {
    margin-bottom: 60px;
}


.filter-button {
    display: block;
    margin: 0 auto;
    cursor: pointer;

    span {
        width: 260px;
        height: 90px;
        margin: 0 auto 60px;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        border: solid 2px $color-macaroni;
        text-transform: uppercase;
        font-weight: bold;

        @include media-breakpoint-up(sm) {
            width: 340px;
        }
    }

    input:checked + span {
        font-weight: bold;
    }
}


.filter-checkbox {
    cursor: pointer;

    label {
        margin-bottom: 0;

    }

    span {
        display: inline-block;
        font-size: 22px;
        font-weight: 900;
        padding: 2px 5px;
        text-transform: uppercase;
        margin: 0 10px 0 0;
        white-space: nowrap;
        overflow: clip;
        background: $color-cool-blue;
        letter-spacing: 0.44px;
        color: $black;
    }

    input:checked + span {
        background-color: $color-macaroni;
    }
}

.filter-businesses-toggle {
    cursor: pointer;
}

.filter-holder {
    max-width: 1200px;
    margin-right: auto;
    margin-left: auto;
    padding: 30px;
    background-color: $color-peacock-blue;

    @include media-breakpoint-up(lg) {
        padding: 30px 50px;

    }

    h2 {
        letter-spacing: 2px;
    }

    h3 {
        text-decoration: none;
    }

}


.listing-container {
    display: grid;
    grid-template-columns: minmax(0, 576px);
    justify-content: center;
    grid-gap: 10px;

    @include media-breakpoint-up(md) {
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        grid-gap: 16px;
    }

    @include media-breakpoint-up(xl) {
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
        padding-right: 60px;
        padding-left: 60px;
    }

    @include media-breakpoint-up(xxl) {
        padding-right: 0;
        padding-left: 0;
    }



    .listing-outer {
        container-type: inline-size;
        container-name: voucher-card;
    }

    .listing-inner {
        background: $color-light-grey;
        border: 1px solid $color-cool-blue;
        display: flex;
        flex-direction: column;
        padding: 1rem;

        @supports (container-type:inline-size) {
            @container voucher-card (min-width: 480px) {
                padding: 1.5rem;
            }
            @container voucher-card (min-width: 550px) {
                padding: 2rem;
            }
        }

        @supports not (container-type:inline-size) {
            @include media-breakpoint-up(lg) {
                padding: 2rem;
            }
        }
    }

    .inner-text {
        .h4 {
            @include brandon-black;
            color: $color-black;
            display: -webkit-box;
            text-transform: uppercase;
            margin: 30px 0 25px;
            font-size: 22px;
            max-height: 2lh;
            letter-spacing: 0.44px;
            overflow: hidden;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-clamp: 2;

            &.no-mt {
                margin-top: 0;
            }
        }

        .voucher-link,
        .voucher-address {
            display: flex;
            flex-wrap: nowrap;

            .fe {
                margin-right: 15px;
                color: $color-peacock-blue;
            }

            a {
                @include brandon-bold;
                color: $color-black;
                text-decoration: none;
                border-bottom: 2px solid $color-macaroni;
            }

        }

        .voucher-categories {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            margin-top: 25px;
            line-height: 1rem;

            & > span {
                @include brandon-black;
                display: inline-block;
                padding: 2px 5px;
                background-color: $color-cool-blue;
                overflow: hidden;
                font-size: 22px;
                letter-spacing: 0.44px;
                max-width: 100%;
                white-space: nowrap;
                text-overflow: ellipsis;
                text-transform: uppercase;
            }
        }
    }

}


</style>
